module.exports = __webpack_public_path__ + "static/feature3-1930c44d55fca0e0a16fda5d8dda7ac6.png";